{
  "min": -590,
  "max": 600,
  "R": [0, 241, 241, 248, 248, 178, 178, 232, 255, 255, 255],
  "G": [0, 156, 156, 222, 222, 36, 36, 51, 255, 255, 255],
  "B": [0, 130, 130, 169, 169, 24, 24, 37, 255, 255, 255],
  "A": [0, 8, 0, 0, 0, 64, 64, 0, 0, 222, 222],
  "I": [0, 2, 3, 64, 122, 142, 172, 182, 252, 253, 255]
}
